<script setup lang="ts">
import { computed } from 'vue';

type StarType = 'full' | 'half' | 'empty';

const props = defineProps<{
  value: number | null;
  max?: number;
  showValue?: boolean;
}>();

const maxStars = props.max ?? 5;

const stars = computed<StarType[]>(() => {
  if (props.value === null || props.value === undefined) {
    return Array(maxStars).fill('empty');
  }

  const rating = Math.max(0, Math.min(props.value, maxStars));
  const fullStars = Math.floor(rating);
  const decimal = rating - fullStars;

  const result: StarType[] = [];

  for (let i = 0; i < fullStars; i++) {
    result.push('full');
  }

  if (result.length < maxStars) {
    if (decimal >= 0.25 && decimal < 0.75) {
      result.push('half');
    } else if (decimal >= 0.75) {
      result.push('full');
    }
  }

  while (result.length < maxStars) {
    result.push('empty');
  }

  return result;
});
</script>

<template>
  <div
  class="rating"
  :title="value !== null ? `${value.toFixed(1)} / ${maxStars}` : 'Aucune notation'"
>
  <!-- Étoiles -->
  <template v-if="value !== null">
    <span
      v-for="(star, index) in stars"
      :key="index"
      class="rating-star-wrapper"
    >
      <!-- pleine -->
      <span
        v-if="star === 'full'"
        class="material-symbols-rounded rating-star"
      >
        star
      </span>

      <!-- vide -->
      <span
        v-else-if="star === 'empty'"
        class="material-symbols-rounded rating-star empty"
      >
        star
      </span>

      <!-- demi -->
      <span v-else class="half-star">
        <span class="material-symbols-rounded rating-star empty">
          star
        </span>
        <span class="material-symbols-rounded rating-star half">
          star
        </span>
      </span>
    </span>
  </template>

  <!-- Non noté -->
  <span v-else class="rating-value text-muted">
    —
  </span>
</div>

</template>

<style scoped>
.rating {
  display: flex;
  align-items: center;
  gap: 2px;
}

.rating-star-wrapper {
  position: relative;
  display: inline-block;
}

.rating-star {
  font-size: 18px !important ;
  color: #fbbc04 !important;; 
  line-height: 1;
}

.rating-star.empty {
  color: #e0e0e0 !important;;
}

/* Demi étoile */
.half-star {
  position: relative;
  display: inline-block;
}

.half-star .half {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  overflow: hidden;
  color: #fbbc04 !important;;
}

.rating-value {
  margin-left: 6px;
  font-size: 13px;
  color: #5f6368 !important;;
}



</style>
